import { BloodGlucoseUnit } from '@libs/shared/interfaces/couch/models/user';
import { IsIn } from 'class-validator';

export class BloodGlucoseUnitUpdateDto {
  @IsIn(['MG_DL', 'MMOL_L'])
  bloodGlucoseUnit!: BloodGlucoseUnit;
}
